import { TABLE_TYPES } from '../../tableTypes';
import { SECTION_2_TABLE_NAMES_V1 as SECTION_2_TABLE_NAMES } from '../tableNames';
import { HEDGE_FUND_AGGREGATED_ASSETS_EXPOSURE_COLUMNS } from '../contstants';

export const SECTION_2_TABLES = {
  [SECTION_2_TABLE_NAMES.HEDGE_FUND_AGGREGATED_ASSETS_EXPOSURE]: {
    type: TABLE_TYPES.GROUP,
    groupColumn: 'sub_asset_class',
    questionLevels: HEDGE_FUND_AGGREGATED_ASSETS_EXPOSURE_COLUMNS.questionLevels,
    virtualized: true
  },
  [SECTION_2_TABLE_NAMES.HEDGE_FUND_EXPOSURE_TRADING]: {
    type: TABLE_TYPES.GROUP,
    groupColumn: 'sub_asset_class',
    questionLevels: HEDGE_FUND_AGGREGATED_ASSETS_EXPOSURE_COLUMNS.questionLevels,
    virtualized: true
  },
  [SECTION_2_TABLE_NAMES.BASE_CURRENCY_INFORMATION]: {
    questionLevels: [
      {
        columns: {
          currency_code: { name: 'Base Currency Code' },
          currency_other_text: { name: 'Other Text' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.TURNOVER]: {
    type: TABLE_TYPES.TURNOVER,
    groupColumn: 'sub_asset_class',
    questionLevels: [
      {
        // name: 'For each month of the reporting period, provide the value of turnover during the month in each of the asset classes listed below for the reporting fund.',
        columns: {
          // instrument_type: { name: 'Instrument Type' },
          month_1: { name: '1st Month' },
          month_2: { name: '2nd Month' },
          month_3: { name: '3rd Month' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.GEOGRAPHICAL_BREAKDOWN_BY_REGION]: {
    questionLevels: [
      {
        name: 'Provide a geographical breakdown of the investments held by the hedge funds that you advise (by percentage of the total net asset value of these hedge funds).',
        level: '(a)',
        columns: {
          percent_nav_in_africa: { name: 'Africa', level: 'i' },
          percent_nav_in_asia_pacific: {
            name: 'Asia and Pacific',
            level: 'ii'
          },
          percent_nav_in_europe_eea: { name: 'Europe (EEA)', level: 'iii' },
          percent_nav_in_europe_non_eea: { name: 'Europe (other than EEA)', level: 'iv' },
          percent_nav_in_middle_east: { name: 'Middle East', level: 'v' },
          percent_nav_in_north_america: { name: 'North America', level: 'vi' },
          percent_nav_in_south_america: { name: 'South America', level: 'vii' },
          percent_nav_in_supranational: { name: 'Supranational', level: 'viii' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.GEOGRAPHICAL_BREAKDOWN_BY_COUNTRY]: {
    questionLevels: [
      {
        name: 'Provide the value of investments in the following countries held by the hedge funds that you advise (by percentage of the total net asset value of these hedge funds).',
        level: '(b)',
        columns: {
          percent_nav_in_brazil: { name: 'Brazil', level: 'i' },
          percent_nav_in_china: { name: 'China (inc. Hong Kong)', level: 'ii' },
          percent_nav_in_india: { name: 'India', level: 'iii' },
          percent_nav_in_japan: { name: 'Japan', level: 'iv' },
          percent_nav_in_russia: { name: 'Russia', level: 'v' },
          percent_nav_in_us: { name: 'United States', level: 'vi' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.LIQUIDITY]: {
    questionLevels: [
      {
        name: "Provide the following information regarding the liquidity of the reporting fund's portfolio",
        columns: {
          portfolio_liquidatable_in_0_to_1_percent: {
            name: '1 day or less'
          },
          portfolio_liquidatable_in_2_to_7_percent: {
            name: '2 days – 7 days'
          },
          portfolio_liquidatable_in_8_to_30_percent: {
            name: '8 days – 30 days'
          },
          portfolio_liquidatable_in_31_to_90_percent: {
            name: '31 days – 90 days'
          },
          portfolio_liquidatable_in_91_to_180_percent: {
            name: '91 days – 180 days'
          },
          portfolio_liquidatable_in_181_to_365_percent: {
            name: '181 days – 365 days'
          },
          portfolio_liquidatable_in_365_more_percent: {
            name: 'Longer than 365 days'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.UNENCUMBERED_CASH]: {
    questionLevels: [
      {
        name: "Value of reporting fund's unencumbered cash",
        columns: {
          unencumbered_cash_month1: { name: '1st Month' },
          unencumbered_cash_month2: { name: '2nd Month' },
          unencumbered_cash_month3: { name: '3rd Month' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.HEDGE_FUND_POSITIONS]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: "For each open position of the reporting fund that represents 5% or more of the reporting fund's net asset value, provide the information requested below.",
        columns: {
          month: { name: 'Month' },
          nav_percent: { name: '% of net asset value' },
          asset_class_cd: { name: 'Sub-asset class' },
          asset_class_other: { name: 'Sub-asset class other' },
          instrument_name: {
            name: 'Instrument name'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.HEDGE_FUND_COLLATERAL_Q36]: {
    type: TABLE_TYPES.RANKING_TABLE,
    rankLevels: ['(a)', '(b)', '(c)', '(d)', '(e)'],
    questionLevels: [
      {
        name: 'For each of the top five counterparties listed in your response to Question 22 with respect to the reporting fund, provide the following information regarding the collateral and other credit support that the counterparty has posted to the reporting fund.',
        columns: {
          ranking: { name: 'Counterparty' },
          counterparty_collateral_cash: {
            name: 'value of cash collateral',
            level: 'i'
          },
          counterparty_collateral_securities: {
            name: 'value of securities collateral',
            level: 'ii'
          },
          counterparty_collateral_posted: {
            name: 'value of other collateral',
            level: 'iii'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.HEDGE_FUND_COLLATERAL_Q37]: {
    type: TABLE_TYPES.RANKING_TABLE,
    rankLevels: ['(a)', '(b)', '(c)', '(d)', '(e)'],
    questionLevels: [
      {
        name: 'For each of the top five counterparties listed in your response to Question 23 with respect to the reporting fund, provide the following information regarding the collateral and other credit support that the reporting fund has posted to the counterparty.',
        columns: {
          ranking: { name: 'Counterparty' },
          counterparty_collateral_cash: {
            name: 'value of cash collateral',
            level: 'i'
          },
          counterparty_collateral_securities: {
            name: 'value of securities collateral',
            level: 'ii'
          },
          counterparty_collateral_posted: {
            name: 'value of other collateral',
            level: 'iii'
          }
        }
      }
    ]
  },

  [SECTION_2_TABLE_NAMES.REHYPOTHECATED_PERCENTAGE]: {
    questionLevels: [
      {
        name: 'Of the total amount of collateral and other credit support that counterparties have posted to the reporting fund, what percentage:',
        level: '(a)',
        columns: {
          maybe_rehypothecated: { name: 'may be rehypothecated?', level: 'i' },
          has_been_rehypothecated: { name: 'has been rehypothecated?', level: 'ii' }
        }
      },
      {
        columns: {
          fund_may_rehypothecate: {
            name: 'Of the total amount of collateral and other credit support that the reporting fund has posted to counterparties, what percentage may be rehypothecated?',
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.CLEAR_TRANSACTIONS_THROUGH_CCP]: {
    questionLevels: [
      {
        columns: {
          clear_transactions_through_ccp: {
            name: 'Did the fund clear any transactions through a CCP?'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.VAR_CALCULATED_REGULARLY]: {
    questionLevels: [
      {
        columns: {
          var_calculated_regularly: {
            level: '(a)',
            name: 'Did you regularly calculate the VaR of the fund?'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.RISK_VAR_CALCULATED]: {
    questionLevels: [
      {
        level: '(b)',
        name: 'If you responded “yes” to Question 40(a), provide the following information.',
        columns: {
          confidence_interval_percent: {
            name: 'Confidence interval used (e.g., 100%-alpha%) (as a percentage)',
            level: 'i'
          },
          time_horizon_days: { name: 'Time horizon used (in number of days)', level: 'ii' },
          weighted_method_code: {
            name: 'What weighting method was used to calculate VaR?',
            level: 'iii'
          },
          weighted_method_code_other: { name: 'Weighted Method Code Other' },
          weighted_factor_value: {
            name: 'If you responded “exponential”, provide the weighting factor used',
            level: 'iv'
          },
          calculation_method_code: { name: 'What method was used to calculate VaR?', level: 'v' },
          calculation_method_code_other: { name: 'Calculation Method Code Other' },
          historical_lookback_period_years: {
            name: 'Historical lookback period (in years; “NA” if none used)',
            level: 'vi'
          },
          var_month1_percent: {
            name: 'VaR at the end of the 1st month of the period (% of NAV).',
            level: 'vii'
          },
          var_month2_percent: {
            name: 'VaR at the end of the 2nd month of the period (% of NAV)',
            level: 'viii'
          },
          var_month3_percent: {
            name: 'VaR at the end of the 3rd month of the period (% of NAV).',
            level: 'ix'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.RISK_VAR_METRIC]: {
    questionLevels: [
      {
        columns: {
          risk_metric_code: {
            name: "Are there any other risk metrics important to the fund's risk management?"
          },
          risk_metric_other: { name: 'Risk Metric Other' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.FINANCING_BORROWING_UNSECURED]: {
    groupColumn: 'sub_asset_class',
    type: TABLE_TYPES.SECURED_BORROWING,
    questionLevels: [
      {
        columns: {
          month: { name: 'Month', disabled: true },
          dollar_amount_unsecured_borrowing: {
            name: 'Dollar amount of unsecured borrowing',
            level: '(a)'
          },
          percentage_borrowed_us_fin_inst: {
            name: 'Percentage borrowed from U.S. financial institutions',
            level: '(i)'
          },
          percentage_borrowed_nonus_fin_inst: {
            name: 'Percentage borrowed from non-U.S. financial institutions',
            level: '(ii)'
          },
          percentage_borrowed_us_nonfin_creds: {
            name: 'Percentage borrowed from U.S. creditors that are not financial institutions',
            level: '(iii)'
          },
          percentage_borrowed_nonus_nonfin_creds: {
            name: 'Percentage borrowed from non-U.S. creditors that are not financial institutions',
            level: '(iv)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.FINANCING_BORROWING_SECURED]: {
    groupColumn: 'sub_asset_class',
    type: TABLE_TYPES.SECURED_BORROWING,
    rankLevels: [
      'i',
      '(A)',
      '(B)',
      '(C)',
      '(D)',
      '(E)',
      '(F)',
      '(G)',
      'ii',
      '(A)',
      '(B)',
      '(C)',
      '(D)',
      '(E)',
      '(F)',
      '(G)',
      'iii',
      '(A)',
      '(B)',
      '(C)',
      '(D)',
      '(E)',
      '(F)',
      '(G)'
    ],
    step: 8,

    questionLevels: [
      {
        columns: {
          month1: { name: '1st Month' },
          month2: { name: '2nd Month' },
          month3: { name: '3rd Month' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.DERIVATIVE_POSITIONS]: {
    questionLevels: [
      {
        name: 'For each month of the reporting period, provide the aggregate value of all derivatives positions of the reporting fund (enter “NA” if no outstanding derivatives positions at the end of the relevant period)....',
        columns: {
          month1: { name: '1st Month' },
          month2: { name: '2nd Month' },
          month3: { name: '3rd Month' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.CCP_COLLATERAL]: {
    questionLevels: [
      {
        name: 'Aggregate net mark-to-market value of all derivatives positions of the fund that were not cleared by a CCP',
        level: '(a)',
        columns: {
          net_mark_to_market_month1_value: { name: '1st Month' },
          net_mark_to_market_month2_value: { name: '2nd Month' },
          net_mark_to_market_month3_value: { name: '3rd Month' }
        }
      },
      {
        name: 'Net value of collateral posted by or to the reporting fund in respect of these positions in the form of cash and cash equivalents ',
        level: '(b)',
        columns: {
          net_cash_collateral_month1_value: { name: '1st Month' },
          net_cash_collateral_month2_value: { name: '2nd Month' },
          net_cash_collateral_month3_value: { name: '3rd Month' }
        }
      },
      {
        name: 'Net value of collateral posted by or to the reporting fund in respect of these positions in the form of securities (other than cash and cash equivalent instruments)',
        level: '(c)',
        columns: {
          net_securities_collateral_month1_value: { name: '1st Month' },
          net_securities_collateral_month2_value: { name: '2nd Month' },
          net_securities_collateral_month3_value: { name: '3rd Month' }
        }
      },
      {
        name: 'Net value of other collateral and credit support posted by or to the reporting fund in respect of these positions (including face amount of letters of credit and similar third party credit support)',
        level: '(d)',
        columns: {
          net_other_collateral_month1_value: { name: '1st Month' },
          net_other_collateral_month2_value: { name: '2nd Month' },
          net_other_collateral_month3_value: { name: '3rd Month' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.TOTAL_FINANCING]: {
    questionLevels: [
      {
        level: '(a)',
        columns: {
          total_financing_amount: {
            name: 'Provide the aggregate dollar amount of borrowing by and cash financing available to the reporting fund (including all drawn and undrawn, committed and uncommitted lines of credit as well as any term financing)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.TOTAL_FINANCING_IN_DAYS]: {
    questionLevels: [
      {
        name: 'Divide the amount reported in response to Question 46(a) among the periods specified below depending on the longest period for which the creditor is contractually committed to provide such financing.',
        columns: {
          total_financing_in_days_0_to_1_percent: { name: '1 day or less' },
          total_financing_in_days_2_to_7_percent: { name: '2-7 days' },
          total_financing_in_days_8_to_30_percent: { name: '8-30 days' },
          total_financing_in_days_31_to_90_percent: { name: '31-90 days' },
          total_financing_in_days_91_to_180_percent: { name: '91-180 days' },
          total_financing_in_days_181_to_365_percent: { name: '181-365 days' },
          total_financing_in_days_365_more_percent: { name: 'Longer than 365 days' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.CREDITORS]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Identify each creditor, if any, to which the reporting fund owed an amount in respect of borrowings equal to or greater than 5% of the reporting fund‟s net asset value as of the data reporting date. For each such creditor, provide the amount owed to that creditor',
        columns: {
          creditor_name_code: { name: 'Name of creditor' },
          creditor_other_description: { name: 'Other Description' },
          amount_owed: { name: 'Dollar amount owed' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.INVESTOR_INFORMATION]: {
    questionLevels: [
      {
        columns: {
          side_pocket_arrangement_percent: {
            name: 'As of the data reporting date, what percentage of the net asset value, if any, is subject to a “side-pocket” arrangement?',
            level: '(a)'
          },
          additional_assets_inside_pocket_code: {
            name: 'Have additional assets been placed in a side-pocket since the end of the prior reporting period?',
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.INVESTOR_WITHDRAWAL_REDEMPTION]: {
    questionLevels: [
      {
        name: "Provide the following information regarding the reporting fund's restrictions on investor withdrawals and redemptions.",
        columns: {
          provide_withdrawal_rights_flag: {
            name: 'Does the fund provide withdrawal/redemption rights in the ordinary course?'
          },
          withdrawal_suspension_maybe_subjected_percent: {
            name: '% May be subjected to a suspension of withdrawals/redemptions'
          },
          withdrawal_material_restriction_maybe_subjected_percent: {
            name: '% May be subjected to restrictions on withdrawals/redemptions'
          },
          withdrawal_suspension_is_subjected_percent: {
            name: '% Is subject to a suspension of investor withdrawals/redemptions'
          },
          withdrawal_material_restriction_is_subjected_percent: {
            name: '% Is subject to a restriction on investor withdrawals/redemptions'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.INVESTOR_LIQUIDITY_DAYS]: {
    questionLevels: [
      {
        name: 'Investor liquidity (as a % of net asset value):',
        columns: {
          investor_liquidity_in_days_0_to_1_percent: { name: '1 day or less' },
          investor_liquidity_in_days_2_to_7_percent: { name: '2-7 days' },
          investor_liquidity_in_days_8_to_30_percent: { name: '8-30 days' },
          investor_liquidity_in_days_31_to_90_percent: { name: '31-90 days' },
          investor_liquidity_in_days_91_to_180_percent: { name: '91-180 days' },
          investor_liquidity_in_days_181_to_365_percent: { name: '181-365 days' },
          investor_liquidity_in_days_365_more_percent: { name: 'Longer than 365 days' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.OPEN_POSITIONS]: {
    questionLevels: [
      {
        name: 'Total number of open positions',
        columns: {
          total_open_positions_month1: {
            name: '1st Month'
          },
          total_open_positions_month2: {
            name: '2nd Month'
          },
          total_open_positions_month3: {
            name: '3rd Month'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.FINANCING_BORROWING_SECURED_1]: {
    type: TABLE_TYPES.SECURED_BORROWING,
    questionLevels: [
      {
        columns: {
          month: { name: 'Month', disabled: true },
          amount: { name: 'Dollar amount via prime brokerage', level: '(i)' },
          cash_collateral_amount: {
            name: 'Value of collateral posted in the form of cash and cash equivalents',
            level: '(A)'
          },
          securities_collateral_amount: {
            name: 'Value of collateral posted in the form of securities',
            level: '(B)'
          },
          other_collateral_amount: {
            name: 'Value of other collateral and credit support posted',
            level: '(C)'
          },
          us_financial_institution_percent: {
            name: 'Percentage borrowed from U.S. financial institutions',
            level: '(D)'
          },
          non_us_financial_institution_percent: {
            name: 'Percentage borrowed from non-U.S. financial institutions',
            level: '(E)'
          },
          other_us_creditors_percent: {
            name: 'Percentage borrowed from U.S. creditors that are not financial institutions',
            level: '(F)'
          },
          other_non_us_creditors_percent: {
            name: 'Percentage borrowed from non-U.S. creditors that are not financial institutions',
            level: '(G)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.FINANCING_BORROWING_SECURED_2]: {
    type: TABLE_TYPES.SECURED_BORROWING,
    questionLevels: [
      {
        columns: {
          month: { name: 'Month', disabled: true },
          amount: { name: 'Dollar amount via reverse repo', level: '(ii)' },
          cash_collateral_amount: {
            name: 'Value of collateral posted in the form of cash and cash equivalents',
            level: '(A)'
          },
          securities_collateral_amount: {
            name: 'Value of collateral posted in the form of securities',
            level: '(B)'
          },
          other_collateral_amount: {
            name: 'Value of other collateral and credit support posted',
            level: '(C)'
          },
          us_financial_institution_percent: {
            name: 'Percentage borrowed from U.S. financial institutions',
            level: '(D)'
          },
          non_us_financial_institution_percent: {
            name: 'Percentage borrowed from non-U.S. financial institutions',
            level: '(E)'
          },
          other_us_creditors_percent: {
            name: 'Percentage borrowed from U.S. creditors that are not financial institutions',
            level: '(F)'
          },
          other_non_us_creditors_percent: {
            name: 'Percentage borrowed from non-U.S. creditors that are not financial institutions',
            level: '(G)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.FINANCING_BORROWING_SECURED_3]: {
    type: TABLE_TYPES.SECURED_BORROWING,
    questionLevels: [
      {
        columns: {
          month: { name: 'Month', disabled: true },
          amount: { name: 'Dollar amount of other secured borrowings', level: '(iii)' },
          cash_collateral_amount: {
            name: 'Value of collateral posted in the form of cash and cash equivalents',
            level: '(A)'
          },
          securities_collateral_amount: {
            name: 'Value of collateral posted in the form of securities',
            level: '(B)'
          },
          other_collateral_amount: {
            name: 'Value of other collateral and credit support posted',
            level: '(C)'
          },
          us_financial_institution_percent: {
            name: 'Percentage borrowed from U.S. financial institutions',
            level: '(D)'
          },
          non_us_financial_institution_percent: {
            name: 'Percentage borrowed from non-U.S. financial institutions',
            level: '(E)'
          },
          other_us_creditors_percent: {
            name: 'Percentage borrowed from U.S. creditors that are not financial institutions',
            level: '(F)'
          },
          other_non_us_creditors_percent: {
            name: 'Percentage borrowed from non-U.S. creditors that are not financial institutions',
            level: '(G)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.FUND_IDENTIFYING_INFORMATION_Q29]: {
    questionLevels: [
      {
        columns: {
          fund_name: { name: 'Name of the reporting fund ', level: '(a)' },
          fund_id_field: {
            name: 'Private fund identification number',
            level: '(b)'
          }
        }
      }
    ]
  },
  //============================= VERSION 2 =========================================
  [SECTION_2_TABLE_NAMES.QUALIFYING_HEDGE_FUND_INFO]: {
    name: 'Qualifying Hedge Fund Info',
    questionLevels: [
      {
        name: 'Reporting fund identifying information',
        columns: {
          name: { name: 'Name of the reporting fund', level: '(a)' },
          fund_id_field: {
            name: 'Private fund identification number',
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.ASSET_EXPOSURE1]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Report the dollar value of positions in each sub-asset class by instrument type:',
        level: '(a)',
        columns: {
          sub_asset_class: { name: 'Sub-Asset Class', level: '1' },
          instrument_type: { name: 'Instrument Type', level: '1' },
          long_month1: { name: '1st Month - Long', level: '1' },
          short_month1: { name: '1st Month - Short', level: '1' },
          long_month2: { name: '2nd Month - Long', level: '1' },
          short_month2: { name: '2nd Month - Short', level: '1' },
          long_month3: { name: '3rd Month - Long', level: '1' },
          short_month3: { name: '3rd Month - Short', level: '1' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.ASSET_EXPOSURE2]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Report the dollar value of positions for the sub-asset class (not by instrument type) for these sub-asset classes',
        level: '(a)',
        columns: {
          sub_asset_class: { name: 'Sub-Asset Class', level: '2' },
          long_month1: { name: '1st Month - Long', level: '2' },
          short_month1: { name: '1st Month - Short', level: '2' },
          long_month2: { name: '2nd Month - Long', level: '2' },
          short_month2: { name: '2nd Month - Short', level: '2' },
          long_month3: { name: '3rd Month - Long', level: '2' },
          short_month3: { name: '3rd Month - Short', level: '2' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.ASSET_ADJUSTED_EXPOSURE1]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'For each sub-asset class in which the reporting fund held relevant positions, calculate the adjusted exposure of long and short positions by net instrument type, and for fixed income assets, within the same term, using the following maturity buckets: 0-1 year, 1-2 year, 2-5 year, 5-10 year, 10-15 year, 15 with the information you report internally and to current and prospective investors.',
        level: '(b)',
        columns: {
          sub_asset_class: { name: 'Sub-Asset Class', level: '1' },
          long_month1: { name: '1st Month - Long', level: '1' },
          short_month1: { name: '1st Month - Short', level: '1' },
          long_month2: { name: '2nd Month - Long', level: '1' },
          short_month2: { name: '2nd Month - Short', level: '1' },
          long_month3: { name: '3rd Month - Long', level: '1' },
          short_month3: { name: '3rd Month - Short', level: '1' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.ASSET_ADJUSTED_EXPOSURE2]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'If, under your methodologies for internal reporting and reporting to investors, you do not net all positions across all instrument types in monitoring the economic exposure of the reporting fund’s investment positions, you must also (i) report adjusted exposure for each sub-asset class calculated using your internal methodologies, and (ii) describe in Question 4 how your internal methodologies differ from the calculations required by subsection (b)(1).',
        level: '(b)',
        columns: {
          sub_asset_class: { name: 'Sub-Asset Class', level: '2' },
          long_month1: { name: '1st Month - Long', level: '2' },
          short_month1: { name: '1st Month - Short', level: '2' },
          long_month2: { name: '2nd Month - Long', level: '2' },
          short_month2: { name: '2nd Month - Short', level: '2' },
          long_month3: { name: '3rd Month - Long', level: '2' },
          short_month3: { name: '3rd Month - Short', level: '2' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.ASSET_EXPOSURE_INTEREST_RATE_RISK]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Interest rate risk (10-year bond equivalent). For sub-asset classes with interest rate risk, report the 10-year bond equivalent of the sub-asset class long position dollar value and short position dollar value (by instrument type, if applicable) and adjusted exposure. Report 10-year bond equivalent as a long value for positions that have a gain when rates decline, and as a short value for positions that have a loss when rates decline',
        level: '(c)',
        columns: {
          sub_asset_class: { name: 'Sub-Asset Class' },
          instrument_type: { name: 'Instrument Type' },
          long_month1: { name: '1st Month - Long' },
          short_month1: { name: '1st Month - Short' },
          long_month2: { name: '2nd Month - Long' },
          short_month2: { name: '2nd Month - Short' },
          long_month3: { name: '3rd Month - Long' },
          short_month3: { name: '3rd Month - Short' },
          long_month1_adjusted: { name: '1st Month - Long Adjusted' },
          short_month1_adjusted: { name: '1st Month - Short Adjusted' },
          long_month2_adjusted: { name: '2nd Month - Long Adjusted' },
          short_month2_adjusted: { name: '2nd Month - Short Adjusted' },
          long_month3_adjusted: { name: '3rd Month - Long Adjusted' },
          short_month3_adjusted: { name: '3rd Month - Short Adjusted' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.CURRENCY_EXPOSURE]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'For each month of the reporting period, identify each currency to which the reporting fund has long dollar value or short dollar value exposure equal to or exceeding either (1) 5% of the reporting fund’s net asset value or (2) $1 billion and report the long dollar value and short dollar value of this exposure in U.S. dollars.',
        level: '(a)',
        columns: {
          currency: { name: 'Currency' },
          long_month1: { name: '1st Month - Long' },
          short_month1: { name: '1st Month - Short' },
          long_month2: { name: '2nd Month - Long' },
          short_month2: { name: '2nd Month - Short' },
          long_month3: { name: '3rd Month - Long' },
          short_month3: { name: '3rd Month - Short' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.CURRENCY_EXPOSURE_5_PERCENT_OR_1_BILLION]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'For each month of the reporting period, identify each currency to which the reporting fund has long dollar value or short dollar value exposure equal to or exceeding either (1) 5% of the reporting fund’s net asset value or (2) $1 billion and report the long dollar value and short dollar value of this exposure in U.S. dollars.',
        level: '(b)',
        columns: {
          currency: { name: 'Currency' },
          long_month1: { name: '1st Month - Long' },
          short_month1: { name: '1st Month - Short' },
          long_month2: { name: '2nd Month - Long' },
          short_month2: { name: '2nd Month - Short' },
          long_month3: { name: '3rd Month - Long' },
          short_month3: { name: '3rd Month - Short' }
        }
      }
    ]
  },

  [SECTION_2_TABLE_NAMES.COUNTRY_EXPOSURE_5_PERCENT_OR_1_BILLION]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'For each month of the reporting period, identify by ISO country code, each country to which the reporting fund has long dollar value or short dollar value exposure equal or exceeding either (1) 5% of the reporting fund’s net asset value or (2) $1 billion., and report the long dollar value and short dollar value of this exposure in U.S. dollars.',
        columns: {
          country: { name: 'ISO Code' },
          long_month1: { name: '1st Month - Long' },
          short_month1: { name: '1st Month - Short' },
          long_month2: { name: '2nd Month - Long' },
          short_month2: { name: '2nd Month - Short' },
          long_month3: { name: '3rd Month - Long' },
          short_month3: { name: '3rd Month - Short' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.INDUSTRY_EXPOSURE_5_PERCENT_OR_1_BILLION]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: "For each month of the reporting period, identify the reporting fund's exposure by industry, based on the NAICS codes of the underlying exposures, equal or exceeding either: (1) 5% of the reporting fund’s net asset value or (2) $1 billion, and report the long dollar value and short dollar value of this exposure in U.S. dollars.",
        columns: {
          country: { name: 'NAICS Code' },
          long_month1: { name: '1st Month - Long' },
          short_month1: { name: '1st Month - Short' },
          long_month2: { name: '2nd Month - Long' },
          short_month2: { name: '2nd Month - Short' },
          long_month3: { name: '3rd Month - Long' },
          short_month3: { name: '3rd Month - Short' }
        }
      }
    ]
  },

  [SECTION_2_TABLE_NAMES.NETTED_EXPOSURE_FOR_REFERENCE_ASSETS]: {
    groupColumn: 'reference_type',
    rankLevels: ['(a)', '(b)', '(c)'],
    type: TABLE_TYPES.TURNOVER,
    questionLevels: [
      {
        name: 'Report the following with respect to the reporting fund’s long and short netted exposure to reference assets at the end of each month of the reporting period',
        columns: {
          long_month1: { name: '1st Month - Long' },
          short_month1: { name: '1st Month - Short' },
          long_month2: { name: '2nd Month - Long' },
          short_month2: { name: '2nd Month - Short' },
          long_month3: { name: '3rd Month - Long' },
          short_month3: { name: '3rd Month - Short' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.CCP_OR_THIRD_PARTY_EXPOSURE]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Identify each CCP or other third party holding collateral posted by the reporting fund in respect of cleared exposures (including tri-party repo) equal to or exceeding either (1) 5% of the reporting fund’s net asset value as of the data reporting date or (2) $1 billion. (Exclude counterparties reported in Questions 42 and 43). If a different legal entity than the reporting fund owns the collateral, report the entity’s legal name and its LEI, if any.',
        columns: {
          legal_name: { name: 'CCP or Third party legal name' },
          legal_entity_id: { name: 'LEI, if any' },
          affiliated_financial_institution: { name: 'Major Financial Institution' },
          other_affiliation: { name: 'Major financial institution - Other' },
          posted_margin: { name: 'Posted Margin (in U.S. dollars)' },
          net_exposure: { name: 'Net Exposure (in U.S. dollars)' },
          entity_legal_name: { name: 'Legal name of entity' },
          entity_lei: { name: 'Entity LEI' }
        }
      }
    ]
  },

  [SECTION_2_TABLE_NAMES.RISK_METRICS_AND_PERFORMANCE]: {
    questionLevels: [
      {
        name: 'Reporting fund risk metrics and performance',
        columns: {
          is_var_calculated: {
            name: 'Retrieving data. Wait a few seconds and try to cut or copy again.',
            level: '(a)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH1]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: "As of the end of each month in the reporting period, provide the information requested below for each reference asset to which the reporting fund has gross exposure equal to or exceeding: (i) 1% of net asset value, if the reference asset is a debt security and the reporting fund’s gross exposure to the reference asset exceeds 20% of the size of the overall debt security issuance; (ii) 1% of net asset value, if the reference asset is a listed equity and the reporting fund’s gross exposure to the reference asset exceeds 20% of average daily trading volume measured over 90 days preceding the reporting date; or (iii) either (1) 5% of the reporting fund's net asset value or (2) $1 billion. First month of the reporting period, Position 1, 2, 3, etc",
        level: '(a)',
        columns: {
          long_value: {
            name: 'Dollar value (in U.S. dollars) of all long positions with legal and contractual rights that provide exposure to the reference asset.'
          },
          short_value: {
            name: 'Dollar value (in U.S. dollars) of all short positions with legal and contractual rights that provide exposure to the reference asset.'
          },
          netted_exposure: {
            name: 'Netted exposure to reference asset (as defined by Question 39 Instructions).'
          },
          sub_asset_class: {
            name: 'Sub-asset class'
          },
          instrument_type: {
            name: 'Instrument Type'
          },
          title_or_description: {
            name: 'Title or description of reference asset'
          },
          issuer_name: {
            name: 'Reference asset issuer (if any) name'
          },
          issuer_lei: {
            name: 'LEI'
          },
          cusip: {
            name: 'CUSIP (if any)'
          },
          isin: {
            name: 'ISIN'
          },
          ticker: {
            name: 'Ticker if ISIN is not available'
          },
          other_identifier: {
            name: 'Other unique identifier (if ticker and ISIN are not available)'
          },
          issue_description: {
            name: 'For reference assets with no CUSIP or other identifier, describe the reference asset'
          },
          issue_size: {
            name: 'If the reference asset is a debt security, size of issue:'
          },
          average_trading_volume: {
            name: 'If the reference asset is a listed equity, average daily trading volume, measured over 90 days preceding the reporting date'
          },
          figi: {
            name: 'FIGI (optional)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH2]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Second month of the reporting period, Position 1, 2, 3, etc.',
        level: '(b)',
        columns: {
          long_value: {
            name: 'Dollar value (in U.S. dollars) of all long positions with legal and contractual rights that provide exposure to the reference asset.'
          },
          short_value: {
            name: 'Dollar value (in U.S. dollars) of all short positions with legal and contractual rights that provide exposure to the reference asset.'
          },
          netted_exposure: {
            name: 'Netted exposure to reference asset (as defined by Question 39 Instructions).'
          },
          sub_asset_class: {
            name: 'Sub-asset class'
          },
          instrument_type: {
            name: 'Instrument Type'
          },
          title_or_description: {
            name: 'Title or description of reference asset'
          },
          issuer_name: {
            name: 'Reference asset issuer (if any) name'
          },
          issuer_lei: {
            name: 'LEI'
          },
          cusip: {
            name: 'CUSIP (if any)'
          },
          isin: {
            name: 'ISIN'
          },
          ticker: {
            name: 'Ticker if ISIN is not available'
          },
          other_identifier: {
            name: 'Other unique identifier (if ticker and ISIN are not available)'
          },
          issue_description: {
            name: 'For reference assets with no CUSIP or other identifier, describe the reference asset'
          },
          issue_size: {
            name: 'If the reference asset is a debt security, size of issue:'
          },
          average_trading_volume: {
            name: 'If the reference asset is a listed equity, average daily trading volume, measured over 90 days preceding the reporting date'
          },
          figi: {
            name: 'FIGI (optional)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.LARGE_EXPOSURE_FOR_REFERENCE_ASSETS_MONTH3]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Third month of the reporting period, Position 1, 2, 3, etc.',
        level: '(c)',
        columns: {
          long_value: {
            name: 'Dollar value (in U.S. dollars) of all long positions with legal and contractual rights that provide exposure to the reference asset.'
          },
          short_value: {
            name: 'Dollar value (in U.S. dollars) of all short positions with legal and contractual rights that provide exposure to the reference asset.'
          },
          netted_exposure: {
            name: 'Netted exposure to reference asset (as defined by Question 39 Instructions).'
          },
          sub_asset_class: {
            name: 'Sub-asset class'
          },
          instrument_type: {
            name: 'Instrument Type'
          },
          title_or_description: {
            name: 'Title or description of reference asset'
          },
          issuer_name: {
            name: 'Reference asset issuer (if any) name'
          },
          issuer_lei: {
            name: 'LEI'
          },
          cusip: {
            name: 'CUSIP (if any)'
          },
          isin: {
            name: 'ISIN'
          },
          ticker: {
            name: 'Ticker if ISIN is not available'
          },
          other_identifier: {
            name: 'Other unique identifier (if ticker and ISIN are not available)'
          },
          issue_description: {
            name: 'For reference assets with no CUSIP or other identifier, describe the reference asset'
          },
          issue_size: {
            name: 'If the reference asset is a debt security, size of issue:'
          },
          average_trading_volume: {
            name: 'If the reference asset is a listed equity, average daily trading volume, measured over 90 days preceding the reporting date'
          },
          figi: {
            name: 'FIGI (optional)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.PERFORMANCE_INVESTMENT_STRATEGY_ITEM]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Reference for Investment Strategy',
        columns: {
          strategy_type: { name: 'Investment Strategy' },
          month1: { name: '1st Month' },
          month2: { name: '2nd Month' },
          month3: { name: '3rd Month' },
          quarterly: { name: 'Quarterly' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.FINANCING_LIQUIDITY]: {
    questionLevels: [
      {
        name: 'Financing Liquidity',
        level: '(a)',
        columns: {
          aggregate_available_amount: {
            name: 'Provide the aggregate dollar amount of borrowing by and cash financing available to the reporting fund (including all drawn and undrawn, committed and uncommitted lines of credit as well as any term financing)'
          }
        }
      },
      {
        name: 'Provide the dollar amount of financing that is available to the reporting fund but not used by type:',
        level: '(b)',
        columns: {
          unsecured_borrowing: { name: 'Unsecured Borrowing', level: 'i' },
          secured_borrowing_prime_brokerage: {
            name: 'Secured Borrowing Prime Brokerage',
            level: 'ii'
          },
          secured_borrowing_reverse_repo: { name: 'Secured Borrowing Reverse Repo', level: 'iii' },
          other_secured_borrowing: { name: 'Other Secured Borrowing', level: 'iv' }
        }
      },
      {
        name: 'Divide the amount reported in response to part (a) among the periods specified below depending on the longest period for which the creditor is contractually committed to provide such financing.',
        level: '(c)',
        columns: {
          one_day_or_less: { name: '1 day or less' },
          days_1_to_7: { name: '2 days - 7 days' },
          days_8_to_30: { name: '8 days - 30 days' },
          days_31_to_90: { name: '31 days - 90 days' },
          days_91_to_180: { name: '91 days - 180 days' },
          days_181_to_365: { name: '181 days - 365 days' },
          longer_than_365_days: { name: 'Longer than 365 days' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.SIDE_POCKET]: {
    questionLevels: [
      {
        name: 'Side Pocket Info',
        columns: {
          nav_percentage_side_pocket: {
            name: "As of the data reporting date, what percentage of the reporting fund's net asset value, if any, is subject to a “side-pocket” arrangement?",
            level: '(a)'
          },
          has_additional_asset_added_in_side_pocket: {
            name: "As of the data reporting date, what percentage of the reporting fund's net asset value, if any, is subject to a “side-pocket” arrangement?",
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.INVESTOR_LIQUIDITY]: {
    questionLevels: [
      {
        name: 'Investor liquidity (as a % of net asset value):',
        columns: {
          one_day_or_less: { name: '1 day or less' },
          days_2_to_7: { name: '2 days - 7 days' },
          days_8_to_30: { name: '8 days - 30 days' },
          days_31_to_90: { name: '31 days - 90 days' },
          days_91_to_180: { name: '91 days - 180 days' },
          days_181_to_365: { name: '181 days - 365 days' },
          longer_than_365_days: { name: 'Longer than 365 days' }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.VAR_ITEM]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: "If you responded 'yes' to Question 46(a), provide the following information. (If you regularly calculate the VaR of the reporting fund using multiple combinations of confidence interval, horizon and historical observation period, complete a separate response to this Question 46(b) for each such combination.)",
        level: '(b)',
        columns: {
          confidence_interval: {
            name: 'Confidence interval used (e.g., 100%-alpha%) (as a percentage)',
            level: 'i'
          },
          time_horizon: {
            name: 'Time horizon used (in number of days)',
            level: 'ii'
          },
          weighting_method: {
            name: 'What weighting method was used to calculate VaR?',
            level: 'iii'
          },
          weighting_factor: {
            name: 'If you responded “exponential” to Question 46(b)(iii), provide the weighting factor used (as a decimal to two places)',
            level: 'iv'
          },
          calculation_method: {
            name: 'What method was used to calculate VaR?',
            level: 'v'
          },
          weighting_method_other_description: {
            name: 'Weighting Method Other',
            level: 'v'
          },
          lookback_period: {
            name: 'Historical lookback period used (in number of years).',
            level: 'vi'
          },
          month1_var: {
            name: 'VaR at the end of the 1st month of the reporting period (as a % of NAV)',
            level: 'vii'
          },
          month2_var: {
            name: 'VaR at the end of the 2nd month of the reporting period (as a % of NAV)',
            level: 'viii'
          },
          month3_var: {
            name: 'VaR at the end of the 3rd month of the reporting period (as a % of NAV)',
            level: 'ix'
          }
        }
      }
    ]
  },
  [SECTION_2_TABLE_NAMES.RISK_METRICS_BY_MARKET_FACTORS]: {
    type: TABLE_TYPES.GROUP_TURNOVER,
    groupColumn: 'asset_class',
    subGroupColumn: 'sub_asset_class',
    commonColumn: 'relevance_type_cd',
    questionLevels: [
      {
        columns: {
          relevance_type_cd: { name: 'Relevance Type' },
          long: { name: 'Long' },
          short: { name: 'Short' }
        }
      }
    ]
  }
};
